import { IconDefinition } from '@ant-design/icons-angular';

export const SignalFill: IconDefinition = {
    name: 'signal',
    theme: 'fill',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><defs><style /></defs><path d="M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z" /></svg>'
}